import {
  FETCH_INVENTORY_INIT,
  FETCH_INVENTORY_SUCCESS,
  FETCH_INVENTORY_FAIL,
  SEND_ITEM_INIT,
  FETCH_COUNTRIES_SUCCESS,
  FETCH_SEGMENTS_SUCCESS,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CAPACITY_SUCCESS,
  FETCH_SUBCAT_SUCCESS,
  FETCH_BRANDS_SUCCESS,
  FETCH_REGION_SUCCESS,
  FETCH_INSURANCE_SUCCESS,
  FETCH_VEHICLE_SUCCESS,
  UPDATE_VEHICLE_INIT_EDIT_ACTION,
  FETCH_LOCATION_SUCCESS,
  FETCH_USER_DRIVERS_SUCCESS,
} from "./action";
import { sortData } from "../../screens/Config/utils";
const initialState = {
  processing: false,
  error: false,
  category1: [{ value: "", name: "All" }],
  category: [],
  subCategory1: [{ value: "", name: "All" }],
  subCategory: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_INVENTORY_INIT:
      return {
        ...state,
        processing: true,
      };

    case FETCH_INVENTORY_SUCCESS:
      return {
        ...state,
        processing: false,
        vehicleList: action.payload.rows,
        totalCount: action.payload.count,
      };

    case FETCH_INVENTORY_FAIL:
      return {
        ...state,
        processing: false,
      };

    case SEND_ITEM_INIT:
      
      return {
        ...state,
        vehicleItems: action.value,
        editVehicle: true,
      };

    case FETCH_COUNTRIES_SUCCESS:
      return {
        ...state,
        avlbleCntries: action.payload.rows,
      };

    case FETCH_SEGMENTS_SUCCESS:
      return {
        ...state,
        avlbleSegments: action.payload.rows,
      };

    case FETCH_CATEGORIES_SUCCESS:
      let tempCategoryData = sortData(action.category);
      return {
        ...state,
        avlbleCategories: action.payload.rows,
        category: [...state.category1, ...tempCategoryData],
      };

    case FETCH_CAPACITY_SUCCESS:
      return {
        ...state,
        avlbleCapacity: action.payload.rows,
      };

    case FETCH_SUBCAT_SUCCESS:
      let tempSubCategoryData = sortData(action.subCategory);
      return {
        ...state,
        avlblesubCat: action.payload.rows,
        subCategory: [...state.subCategory1, ...tempSubCategoryData],
      };

    case FETCH_BRANDS_SUCCESS:
      return {
        ...state,
        avlbleBrands: action.payload.rows,
      };

    case FETCH_REGION_SUCCESS:
      return {
        ...state,
        avlbleRegion: action.payload.rows,
      };

    case FETCH_INSURANCE_SUCCESS:
      return {
        ...state,
        avlbleInsurance: action.payload.rows,
      };

    case FETCH_VEHICLE_SUCCESS:
      return {
        ...state,
        vehicleByIdList: action.payload,
      };

    case FETCH_LOCATION_SUCCESS:
      return {
        ...state,
        avlbleLocation: action.payload.rows,
      };

    case FETCH_USER_DRIVERS_SUCCESS:
      return {
        ...state,
        driverList: action.payload.rows,
        drivercount: action.payload.count,
      };

    default:
      return {
        ...state,
      };
  }
}
